import styled from "styled-components"
import { utility } from "style/style-utils"

export const HiddenText = styled.p`
	${utility.visuallyHidden}
`
